<template>

    <v-container fluid grid-list-xs>
        <div>
            <v-layout row justify-center>
            </v-layout>
            <v-layout row wrap>
                <v-toolbar  style="height: 48px; align-items: baseline;" size="120px" dark color="orange darken-4">
                    <v-toolbar-title class="baslikfont">Satıcılar</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </v-layout>
            <v-card>
                <v-card-title>
                    <v-spacer></v-spacer>
                    <v-text-field append-icon="search" label="Kayıtlar içinde arama" single-line hide-details v-model="search">
                    </v-text-field>
                </v-card-title>
                <v-data-table :headers="headers"  :rows-per-page-items=[5,25,50,100] :items="items" :search="search" id="datatable">
                    <template slot="items" slot-scope="props">
                        <tr @click="git(props.item.Kod)" item>
                            <td class="text-xs-left">{{ props.item.Kod }}</td>
                            <td class="text-xs-left">{{ props.item.Isim }}</td>
                            <td class="text-xs-left">{{ props.item.Tel1 }}</td>
                            <td class="text-xs-left">{{ props.item.Adres }}</td>
                        </tr>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        Aradığınız "{{ search }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                    </v-alert>
                </v-data-table>
            </v-card>

            <template>
                <v-card>
                    <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
                        :vertical="mode === 'vertical'" v-model="snackbar">
                        {{ text }}
                        <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
                    </v-snackbar>
                </v-card>
            </template>
        </div>
    </v-container>
</template>


<script>
    import auth from '../../../../../api/auth'

    export default {
        data() {
            return {
                headers: [{
                        text: 'Kod',
                        value: 'Kod'
                    },
                    {
                        text: 'İsim ',
                        value: 'Isim'
                    },
                    {
                        text: 'Telefon1',
                        value: 'Tel1'
                    },
                    {
                        text: 'Adres',
                        value: 'Adres'
                    }
                ],
                Satici: {
                    Kod: '',
                    Isim: '',
                    Tel1: '',
                    Phone2: '',
                    Mobile: '',
                    Web: '',
                    Authorized: '',
                    WarningNote: '',
                    InfoNote: '',
                    Invoice: {
                        Adres: '',
                        PostCode: '',
                        Province: '',
                        Country: '',
                        TaxNumber: '',
                        TaxOffice: '',
                        IdentityNumber: ''
                    }
                },
                items: [],
                selected: '',
                m: false,
                k: false,
                dialog: false,
                dialog_baslik: '',
                codegorunum: true,
                snackbar: false,
                y: 'top',
                x: 'right',
                mode: '',
                timeout: 6000,
                text: '',
                search: '',
                loading: true
            }
        },
        methods: {
            git: git
        },
        beforeMount: beforeMount,
    }

    function git(v) {

        console.log(v+" Burası coper için tekrar düzenlenecek");
        //var url = "#/cari/goster/" + v
        //window.open(url, '_target')
        //Burası coper için tekrar düzenlenecek
    }

    function beforeMount() {
        console.log(auth)
       
        var SaticiTipi=this.$route.params.saticiTipi;

        var prm ={saticiTipi:SaticiTipi,saticiKodu:"",sqlLike:"",limit:0 }

        this.$http.post(auth.API_URL + 'api/Coper/SaticiList', prm, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {

            this.items = response.body

        }, (response) => {
            if (response.status === 0) {
                console.log('ea')
            } else {
                console.log('ea')
            }
        })
    }
</script>


